/*jslint browser */
/*global process */

import Routing from "./routing";
import Loader from "./loader";

declare var settings: any;

(function ($, global) {
    "use strict";

    const init = function () {
        console.log('xt-framework: ready!');

        const loader = new Loader();
        loader.load();

        const routing = new Routing('xt-framework');
        routing.route();
    }

    $(function () {
        init();
    });
})(jQuery, this)